import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
	actions: {
		padding: '0px 16px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
}));

export default useStyles;
